<template>
  <div class="star">
      <span @click="_click(index+1)" v-for="(item, index) in starList" :key="index" class="star-item" :class="{'on' : item === 'on', 'off' : item === 'off'}"></span>
  </div>
</template>

<script>
export default {
    props: {
        score: {
            type: Number
        }
    },
    data() {
        return {
            // 总体有5个星星
            starLen: 5,
            // 代表全星
            cls_on: 'on',
            // 代表无星
            cls_off: 'off',
            // 代表半星
            cls_half: 'half',
            // 存储星星
            starList: [],
        }
    },
    mounted() {
        this.itemClasses();
    },
    methods: {
        itemClasses () {
            let result = []
            // 只取整数或者类似1.5, 2.5, 3.5 这一类数字
            let score = Math.floor(this.score * 2) / 2
            // 判断score等不等于0， 不等于及有多出的0.5相等于半个星
            // let hasDecimal = score % 1 !== 0
            // 向下取整，判断有多少个全星
            let integer = Math.floor(score)
            // 根据全星的个数循环往数组中添加
            for (let i = 0; i < integer; i++) {
                result.push(this.cls_on)
            }
            // 判断如果有半个星，就往数组添加，因为半颗星最多出现一个，并且总在最后一位
            // if (hasDecimal) {
            //   result.push(CLS_HALF)
            // }
            // 判断一共点亮了几个星，小于总个数的话就补上灰色的星星
            while (result.length < this.starLen) {
                result.push(this.cls_off)
            }
            this.starList = result;
        },
        // 被点击的星
        _click (idx) {
            // 将索引代表分数传递出去, 父级接收到在重新调用方法渲染
            this.$emit('starChang', idx);
        }
    },
}
</script>

<style scoped lang="scss">
.star {
  font-size: 14px;
  .star-item {
        display: inline-block;
        width: 14px;
        height: 14px;
        margin-right: 4px;
        background-size: 14px 14px;
        background-repeat: no-repeat;
        &:last-child {
            margin: 0;
        }
    }
    .star-item.on {
        background-image: url('../assets/images/icon_star_01.png');
    }
    .star-item.off {
        background-image: url('../assets/images/icon_star_02.png');
    }
    // .star-item.half {}
}
</style>